<template>
  <Toast ref="toastRef" />
  <MainLoader :visible="true" size="80px" color="blue" v-if="!hotels?.value || !hotels?.value?.content?.name" />
  <div class="container pb-10" v-else>
    <button type="button" @click="backToMainView" class="my-5 mx-auto lsp-btn px-3 py-2 rounded text-sm font-medium">
      <span> &lt; back</span>
    </button>
    <div class="pb-10 flex justify-between">
      <div>
        <h1 class="text-2xl mb-2 font-bold title">
          {{ hotels.value?.content.name }}
        </h1>
        <div>
          <span v-for="i in hotels.rating" :key="i" class="text-yellow-400">
            <i class="fas fa-star"></i>
          </span>

          <p class="price" v-if="hotels.value?.content?.affiliate_price">
            Price:
            <span class="font-semibold">
              AUD ${{ roundPrice(hotels.value?.content?.affiliate_price) }}
            </span>
          </p>
          <span class="text-gray-600 flex" v-else>
            {{ hotels.value?.content?.ratings?.property?.rating }}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
              class="w-5 h-5 text-yellow-600">
              <path fill-rule="evenodd"
                d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                clip-rule="evenodd"></path>
            </svg>
            {{ `- ${getFullAdress}` }}
          </span>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap gap-4 mb-4">
      <div class="w-full md:flex-[0_0_calc(50%_-_0.5rem)] md:max-w-[calc(50%_-_0.5rem)]">
        <!-- ✅ Use Custom Slider Component -->
        <ImageSlider :images="hotels.value?.images" :imageWiseSlide="true" />
      </div>

      <!-- Map Section -->
      <div class="w-full md:flex-[0_0_calc(50%_-_0.5rem)] md:max-w-[calc(50%_-_0.5rem)]">
        <div class="w-full h-[400px] overflow-hidden rounded-xl mb-4">
          <iframe :src="getMapUrl" class="border-0 w-full h-full"></iframe>
        </div>
        <div class="content-address">
          <p>Address</p>
          <span class="text-gray-600">{{
            hotels.value?.listing.third_party_type === "affiliate"
              ? getFullAdressForAffliate
              : getFullAdress
          }}
          </span>
          <div class="mt-3">
            <span class="text-gray-600" v-if="hotels.value?.listing.stra_number">STRA: #{{
              hotels.value?.listing.stra_number }}</span>
          </div>
          <div class="mt-3" v-if="
            hotels.value?.listing.third_party_type === 'affiliate' &&
            hotels.value?.listing.third_party_snippet
          ">
            <button type="button" @click="
              redirectToParterWebsite(
                hotels.value?.listing.third_party_snippet
              )
              " class="lsp-btn w-full px-4 py-2">
              Book On Partner Website
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8 bg-stone-100 p-5 rounded-md flex flex-wrap gap-2 justify-end sm:!justify-between"
      v-if="hotels.value?.listing.third_party_type !== 'affiliate'">
      <input type="text" name="searchHotelName" placeholder="Search another hotel by name"
        class="w-full sm:!w-1/2 px-4 py-2 border border-stone-300 rounded-lg focus:ring focus:ring-blue-300 focus:outline-none"
        v-model="searchHotelNameDetail">

      <!-- Search Button at the Bottom -->
      <button type="submit" class="float-right lsp-btn px-4 py-2 rounded text-sm font-medium"
        @click="searchByHotelName">
        Search
      </button>
    </div>

    <div class="mt-4 bg-stone-100 p-5 rounded-md" v-if="hotels.value?.listing.third_party_type !== 'affiliate'">
      <div class="flex flex-col gap-4 mb-4">
        <div class="md:flex flex-wrap md:!flex-nowrap gap-4 ">
          <div class="md:mb-0 mb-3">
            <label class="text-sm font-medium text-gray-600 mb-1">Check-in</label>
            <input type="date" v-model="checkinDate"
              class="w-full lg:w-[150px] px-4 py-2 border rounded-lg focus:ring focus:ring-blue-300 focus:outline-none"
              :min="minCheckinDate"
              @change="updateCheckoutMinDate" />
          </div>

          <div class="">
            <label class="text-sm font-medium text-gray-600 mb-1">Check-out</label>
            <input type="date" v-model="checkoutDate"
              class="w-full lg:w-[150px] px-4 py-2 border rounded-lg focus:ring focus:ring-blue-300 focus:outline-none"
              :min="minCheckoutDate" />
          </div>

          <div class="w-full ml-0 md:!ml-10 flex flex-col gap-4">
            <div v-for="(room, index) in rooms" :key="index" class="md:flex items-center flex-wrap gap-4">
              <h4 class="mt-5 text-sm font-semibold text-stone-900">Room {{ index + 1 }}</h4>

              <div class="mb-3">
                <label class="block text-sm font-medium text-gray-600 mb-1">Adults</label>
                <input type="number" v-model.number="room.adults" min="1" max="6"
                  class="px-3 py-2 border rounded-lg w-full lg:w-[60px]" @input="validateAdults(room)" />
              </div>

              <div class="mb-3">
                <label class="block text-sm font-medium text-gray-600 mb-1">Children<span
                    class="text-[11px]">(s)</span></label>
                <input type="number" v-model.number="room.children" min="0" max="4"
                  class="px-3 py-2 border rounded-lg w-full lg:[60px]" @input="validateChildren(room)" />
              </div>

              <div v-if="room.children > 0" class="md:flex flex-wrap gap-6">
                <div v-for="(child, childIndex) in room.children" :key="childIndex" class="mb-3">
                  <label class="block text-sm font-medium text-gray-600 mb-1">Child {{ childIndex + 1 }} Age</label>
                  <input type="number" v-model.number="room.ages[childIndex]" min="0" max="17"
                    class="px-3 py-2 border rounded-lg w-full lg:w-[60px]"
                    @input="validateChildAge(room, childIndex)" />
                </div>
              </div>

              <button type="button" v-if="index > 0" @click="removeRoom(index)"
                class="cursor-pointer rounded-full bg-red-600 py-[4px] px-[10px] text-white">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="h-5 w-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div class="flex justify-end gap-4 mt-4">
              <button type="button" href="javascript:void(0)" @click="addRoom"
                class="hidden bg-gray-800 px-3 py-2 text-white rounded-lg hover:bg-gray-950">
                <i class="fa fa-plus text-white"></i> Add Another Room
              </button>

              <button type="submit" class="lsp-btn px-4 py-2 rounded text-sm font-medium" @click="getPropertyData">
                Search
              </button>

              <button type="button" class="lsp-btn px-4 py-2 rounded text-sm font-medium grey" @click="getResetData">
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="my-6" v-if="hotels.value?.content.listing_description">
      <h3 class="mb-2 text-base font-semibold leading-6 text-stone-700">
        Property Description
      </h3>
      <hr />
      <p class="my-6" v-html="hotels.value?.content?.listing_description"></p>
      <hr />
    </div>

    <div class="my-6" v-if="hotels.value?.rooms?.length">
      <h3 class="mb-2 text-base font-semibold leading-6 text-stone-700">
        Available Rooms
      </h3>
      <div class="mt-8">
        <div v-for="(groupRoom, index) in hotels?.value?.rooms" :key="index"
          class="my-4 border border-gray-300 rounded-lg">
          <div class="flex">
            <div class="relative">
              <img :src="groupRoom[0].images[groupRoom[0].images.length - 1] ||
                defaultImage
                " :alt="groupRoom[0].name" class="rounded-lg object-cover h-28 w-36 rounded-tl-lg" />
              <button type="button" v-if="groupRoom[0]?.images?.length"
                class="absolute bg-white bottom-2 px-[10px] text-sky-600 text-xs"
                @click="openImageDialog(groupRoom[0])">
                {{ groupRoom[0]?.images?.length }} photos
              </button>
              <Dialog v-model="selectedRoomForImages" v-if="selectedRoomForImages === groupRoom[0]">
                <ImageSlider :images="groupRoom[0].images" :imageWiseSlide="false" />
              </Dialog>
            </div>
            <div class="w-3/4 p-4">
              <h2 class="text-xl font-bold">{{ groupRoom[0]?.name }}</h2>
              <span>{{ groupRoom[0]?.name_struct?.bedding_type }}</span>
              <div class="flex gap-2 mt-3 overflow-x-auto [&::-webkit-scrollbar]:w-0 [&::-webkit-scrollbar]:h-0">
                <div v-for="amenity in groupRoom[0]?.amenities?.room" :key="amenity"
                  class="flex items-center p-2 bg-gray-100 rounded text-sm pl-4 relative">
                  <img :src="getAmenityIcon(amenity)" :alt="amenity"
                    class="w-5 h-5 absolute left-0 top-1/2 -translate-y-1/2" v-if="getAmenityIcon(amenity)" />
                  <span class="ml-2 whitespace-nowrap inline-block">{{ amenity }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full  overflow-x-auto lg:!overflow-x-visible overflow-y-visible">
            <table class=" text-sm w-full">
              <thead class="bg-gray-800 text-white w-full">
                <tr>
                  <th class="px-4 py-2 border-r border-gray-300">Room</th>
                  <th class="px-4 py-2 border-r border-gray-300">Meals</th>
                  <th class="px-4 py-2 border-r border-gray-300">Price</th>
                  <th class="px-4 py-2 border-r border-gray-300">Cancellation</th>
                  <th class="px-4 py-2">Action</th>
                </tr>
              </thead>
              <tbody class="w-full">
                <tr :class="{ 'border-b': room !== groupRoom[groupRoom.length - 1] }" v-for="room in groupRoom"
                  :key="room.id">
                  <td class="px-4 py-2 border-r border-gray-300 w-[500px]">
                    <div class="flex flex-col">
                      <span class="font-medium uppercase py-1 text-gray-700 whitespace-nowrap">{{
                        room.name
                      }}</span>
                      <span class="text-gray-500" v-for="(aminitiy, index) in room?.amenities?.rate" :key="index">{{ aminitiy }}</span>
                    </div>
                  </td>
                  <td class="px-4 py-2 border-r border-gray-300 capitalize">
                    {{ room?.meal }}
                  </td>
                  <td class="px-4 py-2 border-r border-gray-300">
                    <span class="font-bold text-stone-700 whitespace-nowrap">
                      Total: AUD ${{
                        roundPrice(room?.totals?.total)
                          ? roundPrice(room.totals.total)
                          : "0.00"
                      }}</span><br />
                    <span class="text-sm text-gray-500">for 1 room</span><br />
                    <div class="flex items-center justify-evenly"></div>
                    <span class="text-gray-500 cursor-pointer" @click="openPriceDialog(room)">Price Details
                      <span class="text-gray-500 text-lg">&#9432;</span></span>
                    <Dialog v-model="selectedRoomForPrice" v-if="selectedRoomForPrice === room">
                      <div class="modal-body w-full text-gray-500 mt-6 min-w-[300px] max-w-[500px]">
                        <strong id="pricing-model-label-6" class="mb-4 text-2xl text-black">
                          <b>{{ room?.name }}</b>
                        </strong>
                        <table class="w-full mt-6">
                          <tbody>
                            <tr>
                              <td class="py-1">Sub-Total</td>
                              <td class="py-1 text-right">
                                AUD ${{ formatPrice(room?.totals?.subtotal) }}
                              </td>
                            </tr>
                            <tr>
                              <td class="py-1">Taxes</td>
                              <td class="py-1 text-right">
                                AUD ${{ formatPrice(room?.totals?.gst_amount) }}
                              </td>
                            </tr>

                            <tr class="border-t border-stone-300">
                              <td>Total</td>
                              <td class="text-right">
                                <div class="font-bold text-stone-700">
                                  AUD ${{ formatPrice(room?.totals?.total) }}
                                </div>
                                <div class="text-xs text-stone-500">
                                  for 1 room
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="text-center">
                          <button type="button" @click="bookRoom(room)"
                            class="lsp-btn mt-3 mx-auto px-3 py-2 rounded text-sm font-medium">
                            Book
                          </button>
                        </div>
                      </div>
                    </Dialog>
                  </td>
                  <td class="px-4 py-2 font-semibold border-r border-gray-300 group relative">
                    <div class="flex items-center justify-evenly">
                      {{
                        room?.cancellation_policy?.free?.length
                          ? "Free Cancellation"
                          : room?.cancellation_policy?.norefund_after?.length
                            ? "Non-Refundable"
                            : "Non-Refundable"
                      }}
                      <span class="text-gray-500 cursor-pointer" @click="openPolicyDialog(room)">
                        <span class="text-gray-500 text-lg">&#9432;</span></span>

                      <Dialog 
                      :fromWhere="'policy'" v-model="selectedRoomForPolicy" v-if="selectedRoomForPolicy === room"
                        class="p-0">
                        <div class="relative inline-block">
                          <!-- Tooltip Content -->
                          <div class="bg-gray-800 text-white text-sm rounded-xl p-4 z-20">
                            <h3 class="text-lg font-semibold mb-1 text-white">Cancellation Policy</h3>

                            <div v-if="selectedRoomForPolicy.cancellation_policy.free"
                              class="flex items-stretch mb-2.5">
                              <span class="w-2 bg-green-600 rounded-full mr-2.5"></span>
                              <p class="flex-1">{{ selectedRoomForPolicy.cancellation_policy.free }}</p>
                            </div>

                            <div v-if="selectedRoomForPolicy.cancellation_policy.partial"
                              class="flex items-stretch mb-2.5">
                              <span class="w-2 bg-yellow-600 rounded-full mr-2.5"></span>
                              <p class="flex-1">{{ selectedRoomForPolicy.cancellation_policy.partial }}</p>
                            </div>

                            <div v-if="selectedRoomForPolicy.cancellation_policy.norefund_after"
                              class="flex items-stretch mb-2.5">
                              <span class="w-2 bg-red-600 rounded-full mr-2.5"></span>
                              <p class="flex-1">{{ selectedRoomForPolicy.cancellation_policy.norefund_after }}</p>
                            </div>

                            <div v-if="selectedRoomForPolicy.cancellation_policy.norefund"
                              class="flex items-stretch mb-2.5">
                              <span class="w-2 bg-red-600 rounded-full mr-2.5"></span>
                              <p class="flex-1">{{ selectedRoomForPolicy.cancellation_policy.norefund }}</p>
                            </div>

                            <div v-if="selectedRoomForPolicy.cancellation_policy.terms"
                              class="flex items-stretch mb-2.5">
                              <span class="w-2 bg-sky-600 rounded-full mr-2.5"></span>
                              <p class="flex-1" v-html="selectedRoomForPolicy.cancellation_policy.terms"></p>
                            </div>
                          </div>
                        </div>
                      </Dialog>
                    </div>
                  </td>
                  <td class="px-4 py-2" style="justify-content: space-evenly">
                    <div class="flex flex-col md:!flex-row items-center gap-2">
                      <button type="button" @click="openRoomDetails(room)"
                        class="lsp-btn mx-auto px-3 py-2 rounded text-sm font-medium grey whitespace-nowrap">
                        More Details
                      </button>
                      <Dialog v-model="showDialog">
                        <div v-if="selectedRoom"></div>
                        <h2>Room Information</h2>
                        <div class="grid md:grid-cols-2 gap-4">
                          <div>
                            <div>
                              <h3 class="mb-2 text-xl">{{ selectedRoom?.name }}</h3>
                            </div>
                            <div>
                              <h3 class="mb-2 text-xl">Room Amenities</h3>
                              <ul class="my-2">
                                <li v-for="aminitiy in selectedRoom?.amenities?.room" :key="aminitiy"
                                  class="text-sm text-stone-600">
                                  {{ aminitiy }}
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div>
                            <ImageSlider :images="selectedRoom?.images" :imageWiseSlide="false" />
                            <div class="mt-2">
                              <div class="mb-2 rounded border p-4">
                                <h3 class="text-lg">Room options</h3>
                                <span class="text-sm text-stone-600 capitalize"><b>Meal:</b> {{ selectedRoom?.meal
                                }}</span>
                                <ul class="my-2">
                                  <li v-for="aminitiy in selectedRoom?.amenities
                                    ?.rate" :key="aminitiy" class="text-sm text-stone-600">
                                    {{ aminitiy }}
                                  </li>
                                </ul>
                                <span class="font-medium">{{
                                  selectedRoom?.name
                                }}</span>

                                <p class="border-t border-stone-200 pt-2 text-xs italic text-stone-500">
                                  Choices between multiple bed types for the same
                                  room are requests only and may not be honored at
                                  the hotel if availability does not permit
                                </p>
                              </div>
                              <div class="mb-2 rounded border p-4">
                                <div class="flex justify-between">
                                  <div class="my-2 w-1/2">
                                    <div class="font-bold text-stone-700">
                                      Total: AUD ${{ roundPrice(selectedRoom?.totals?.total) }}
                                    </div>
                                    <div class="text-xs text-stone-500">
                                      <p>Including 10% GST</p>
                                    </div>
                                    <div class="text-xs text-stone-500">
                                      for 1 room
                                    </div>
                                  </div>
                                  <div>
                                    <button type="button" @click="bookRoom(room)"
                                      class="lsp-btn mt-3 mx-auto px-3 py-2 rounded text-sm font-medium">
                                      Book
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="rounded border border-stone-300 p-4 text-sm">
                                <div class="mb-4 text-sm text-stone-600">
                                  <h4 class="mb-1 font-bold">Policies</h4>
                                  <hr />
                                </div>
                                <div class="mb-4 text-sm text-stone-600">
                                  <strong class="mb-1 font-bold">Cancellation:</strong>
                                  <li v-if="
                                    selectedRoom?.cancellation_policy?.free
                                      ?.length
                                  ">
                                    {{ selectedRoom?.cancellation_policy?.free }}
                                  </li>
                                  <li v-if="
                                    selectedRoom?.cancellation_policy
                                      ?.norefund_after?.length
                                  ">
                                    {{
                                      selectedRoom?.cancellation_policy
                                        ?.norefund_after
                                    }}
                                  </li>
                                  <li v-if="selectedRoom?.cancellation_policy?.partial?.length">
                                    {{ selectedRoom?.cancellation_policy?.partial }}
                                  </li>
                                  <li v-if="
                                    selectedRoom?.cancellation_policy?.terms
                                      ?.length
                                  ">
                                    <span v-html="selectedRoom?.cancellation_policy?.terms
                                      "></span>
                                  </li>
                                  <br />
                                </div>
                                <div v-if="
                                  hotels.value?.content?.policy_struct?.length
                                ">
                                  <div v-for="(policy, index) in hotels.value?.content
                                    .policy_struct" :key="index" class="mb-4 text-sm text-stone-600">
                                    <strong class="mb-1 font-bold">
                                      {{ policy?.title }}
                                    </strong>

                                    <template v-for="(
paragraph, pIndex
                                  ) in policy?.paragraphs" :key="pIndex">
                                      <ul v-if="paragraph.includes('<ul>')" v-html="paragraph"></ul>
                                      <p v-else v-html="paragraph"></p>
                                    </template>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Dialog>
                      <button type="button" @click="bookRoom(room)"
                        class="lsp-btn mx-auto px-3 py-2 rounded text-sm font-medium whitespace-nowrap">
                        Book Now
                      </button>
                    </div>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <p v-else class="my-6 text-center"><span v-if="hotels.value?.listing.third_party_type !== 'affiliate'">No rooms
        found!</span></p>

    <!-- Room Section -->
    <div class="mb-4 bg-stone-100 shadow-sm sm:rounded-lg" v-if="
      isArray(hotels?.value?.content?.descriptions)
        ? hotels?.value?.content?.descriptions?.length
        : hotels?.value?.content?.descriptions
    ">
      <div class="border-b border-stone-300 p-4 sm:px-6">
        <h3 class="text-base font-semibold leading-6 text-stone-700">
          Description
        </h3>
      </div>
      <div>
        <dl class="sm:divide-y sm:divide-stone-200 p-4">
          <div v-for="(value, key) in hotels?.value?.content?.descriptions" :key="key"
            class="py-2 sm:grid sm:grid-cols-3 sm:gap-4  sm:py-5">
            <dt class="text-sm font-medium text-gray-500">{{ key }}</dt>
            <dd class="mt-1 text-sm text-stone-900 sm:col-span-2 sm:mt-0">
              {{ value }}
            </dd>
          </div>
        </dl>
      </div>
    </div>
    <div class="bg-stone-100 p-4 rounded-lg mb-4" v-if="hotels?.value?.amenities?.length">
      <h2 class="text-base font-semibold leading-6 text-stone-700 mb-2">
        Property Amenities
      </h2>
      <hr class="mb-4 border-gray-300" />
      <ul class="grid grid-cols-1 md:!grid-cols-2 lg:!grid-cols-3 list-disc list-inside text-gray-700">
        <li v-for="(amenity, index) in hotels?.value?.amenities" :key="index">
          {{ amenity }}
        </li>
      </ul>
    </div>
    <div class="bg-stone-100 p-4 rounded-lg mb-4" v-if="hotels?.value?.roomAmenities?.length">
      <h2 class="text-base font-semibold leading-6 text-stone-700 mb-2">
        Room Amenities
      </h2>
      <hr class="mb-4 border-gray-300" />
      <ul class="grid grid-cols-1 md:!grid-cols-2 lg:!grid-cols-3 list-disc list-inside text-gray-700">
        <li v-for="(amenity, index) in hotels?.value?.roomAmenities" :key="index">
          {{ amenity }}
        </li>
      </ul>
    </div>
    <div class="bg-stone-100 p-4 rounded-lg mb-4" v-if="hotels?.value?.content?.attributes?.general?.length">
      <ul class="grid grid-cols-1 md:!grid-cols-2 lg:!grid-cols-3 list-disc list-inside text-gray-700">
        <li v-for="(amenity, index) in hotels?.value?.content?.attributes
          ?.general" :key="index">
          {{ amenity }}
        </li>
      </ul>
    </div>
    <div class="mb-4 bg-stone-100 shadow-sm sm:rounded-lg" v-if="hotels?.value?.content?.metapolicy_extra_info?.length">
      <div class="border-b border-stone-300 p-4 sm:px-6">
        <h3 class="text-base font-semibold leading-6 text-stone-700">
          Additional Information
        </h3>
      </div>
      <div class="p-4 sm:p-6 text-sm text-stone-900">
        <!-- Try these different paths -->
        <span v-html="hotels?.value?.content?.metapolicy_extra_info"></span>
        <!-- or -->
      </div>
    </div>
    <div class="my-6" v-if="hotels?.value?.content?.metapolicy_struct">
      <h3 class="mb-2 text-base font-semibold leading-6 text-stone-700">
        Policies
      </h3>
      <PolicySection :meta-policy-struct="hotels?.value?.content?.metapolicy_struct" class="mt-8" />
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, nextTick } from "vue";
import api from "../../utils/api.js";
import ImageSlider from "../../src/UI/imageSlider.vue";
import Dialog from "../../src/UI/dialogue.vue";
import PolicySection from "../../src/UI/PolicySection.vue";
import { useSearchStore } from "../../stores/search.module";
import { useBookingStore } from "../../stores/booking.module.js";
import { useComponentChangeStore } from "../../stores/componentChange.module.js";
import { roundPrice, formatPrice } from "../../utils/imageFunction.js";
import toolTip from "../../src/UI/toolTip.vue";
import MainLoader from "../../src/UI/mainLoader.vue";
import { isArray } from "lodash";
import { API_URL } from "../../src/constants.js";
import Toast from "../../src/UI/toast.vue";

const bookingStore = useBookingStore();
const searchStore = useSearchStore();
const componentChangeStore = useComponentChangeStore();

const defaultImage = API_URL + `/images/image-not-found.jpg`;
const toastRef = ref(null);
const showDialog = ref(false);
const searchHotelNameDetail = ref("");
const hotels = reactive({});
const selectedRoom = ref(null);
const selectedRoomForImages = ref(null);
const selectedRoomForPrice = ref(null);
const selectedRoomForPolicy = ref(false);

const checkinDate = ref();
const checkoutDate = ref();
const rooms = ref([{ adults: 2, children: 0, ages: [] }]);

const addRoom = () => {
  rooms.value.push({ adults: 1, children: 0, ages: [] });
};

const removeRoom = (index) => {
  if (rooms.value.length > 1) {
    rooms.value.splice(index, 1);
  }
};

const validateAdults = (room) => {
  room.adults = Math.min(6, Math.max(1, room.adults));
};

const validateChildren = (room) => {
  room.children = Math.min(4, Math.max(0, room.children));
  room.ages = room.ages.slice(0, room.children); // Adjust ages array if children count changes
};

// Enforce child age limit (0-17)
const validateChildAge = (room, index) => {
  room.ages[index] = Math.min(17, Math.max(0, room.ages[index]));
};

const openImageDialog = (room) => {
  selectedRoomForImages.value = room;
};

const openPriceDialog = (room) => {
  selectedRoomForPrice.value = room;
};

const openPolicyDialog = (room) => {
  selectedRoomForPolicy.value = room;
};


const getMapUrl = computed(() => {
  const lat = hotels.value?.content?.location?.coordinates?.latitude;
  const lng = hotels.value?.content?.location?.coordinates?.longitude;

  if (lat && lng) {
    return `https://maps.google.com/maps?width=600&height=400&hl=en&q=${lat},${lng}&t=&z=15&ie=UTF8&iwloc=B&output=embed`;
  }
  return null;
});

const updateCheckoutMinDate = () => {
  if (checkoutDate.value && checkoutDate.value < minCheckoutDate.value) {
    checkoutDate.value = minCheckoutDate.value;
  }
};

const minCheckinDate = computed(() => {
  const today = new Date();
  return today.toISOString().split("T")[0]; // Convert to YYYY-MM-DD
});

const minCheckoutDate = computed(() => {
  if (!checkinDate.value) return ""; // If no check-in selected
  const date = new Date(checkinDate.value);
  date.setDate(date.getDate() + 2); // Add 2 days
  return date.toISOString().split("T")[0]; // Convert to YYYY-MM-DD
});

const getFullAdress = computed(() => {
  return `${hotels.value?.content?.address?.line_1 !== null
    ? hotels.value?.content?.address?.line_1
    : ""
    }, ${hotels.value?.content?.address?.city !== null
      ? hotels.value?.content?.address?.city
      : ""
    }, ${hotels.value?.content?.address?.state_province_name !== null
      ? hotels.value?.content?.address?.state_province_name
      : ""
    }, ${hotels.value?.content?.address?.postal_code !== null
      ? hotels.value?.content?.address?.postal_code
      : ""
    } `;
});
const getFullAdressForAffliate = computed(() => {
  return `${hotels.value?.listing?.address_line1 !== null
    ? hotels.value?.listing?.address_line1
    : ""
    }, ${hotels.value?.listing?.address_line2 !== null
      ? hotels.value?.listing?.address_line2
      : ""
    },${hotels.value?.listing?.postcode !== null
      ? hotels.value?.listing?.postcode
      : ""
    },${hotels.value?.listing?.suburb !== null ? hotels.value?.listing?.suburb : ""
    },
   ${hotels.value?.listing?.county !== null ? hotels.value?.listing?.county : ""
    }, ${hotels.value?.listing?.country !== null
      ? hotels.value?.listing?.country
      : ""
    } `;
});
const propertyId = computed(() => {
  return searchStore.getSelectedPropertyId;
});
const selectedPropertyName = computed(() => {
  return searchStore.getSelectedHotelName;
});

const occupancy = computed(() => {
  const rooms = searchStore.getRooms;

  // Check if the rooms data is already in the formatted occupancy format
  if (typeof rooms === "string") {
    return rooms; // Return it directly if it's already in the correct format
  }

  // If rooms is not in the formatted string, format it
  if (Array.isArray(rooms)) {
    const formattedOccupancy = rooms
      .map((room, index) => {
        const adultsCount = room.adults;
        const childrenAges = room.ages.length > 0 ? room.ages.join(",") : "";
        return `occupancy[${index}]=${adultsCount}-${childrenAges}`;
      })
      .join("&");
    return formattedOccupancy;
  }

  return ""; // Return empty string if `rooms` is neither an array nor a formatted string
});

const slugifiedPropertyName = computed(() => {
  return selectedPropertyName.value
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "") // Remove special characters
    .replace(/[\s_-]+/g, "-") // Replace spaces or underscores with a single dash
    .replace(/^-+|-+$/g, ""); // Remove dashes at the beginning or end
});

const getAmenityIcon = (amenity) => {
  if (!amenity) return null;
  const iconName = amenity.toLowerCase().replace(/\s+/g, "-") + ".svg";
  return `${API_URL}/images/amenities/${iconName}`;
};

onMounted(() => {
  restoreStoreData();

  // Check for stored dates in localStorage
  const storedCheckin = localStorage.getItem("selectedCheckin");
  const storedCheckout = localStorage.getItem("selectedCheckout");

  if (storedCheckin && storedCheckout) {
    // Use stored dates if available
    checkinDate.value = storedCheckin;
    checkoutDate.value = storedCheckout;
  }
  
  const todayDateString = new Date().toISOString().split('T')[0];
  if (!checkinDate.value || !checkoutDate.value || checkinDate.value < todayDateString) {
    // Set default dates if no stored dates, no current dates, or stored dates are in the past
    const today = new Date();
    today.setDate(today.getDate() + 14);
    checkinDate.value = today.toISOString().split('T')[0];

    const checkoutDay = new Date(today);
    checkoutDay.setDate(checkoutDay.getDate() + 2);
    checkoutDate.value = checkoutDay.toISOString().split('T')[0];
  }

  // Update store with dates
  searchStore.setCheckin(checkinDate.value);
  searchStore.setCheckout(checkoutDate.value);

  getPropertyData();
});

function openRoomDetails(room) {
  selectedRoom.value = room;
  showDialog.value = true;
}

function redirectToParterWebsite(url) {
  window.open(url, "_blank");
}

function restoreStoreData() {
  const storedData = JSON.parse(localStorage.getItem("propertyDetailsPayload"));

  if (storedData) {
    if (!searchStore.getSelectedPropertyId) {
      searchStore.setHotelRoomId(storedData.propertyId);
    }

    if (!searchStore.getSelectedHotelName) {
      searchStore.setHotelRoomName(storedData.slugifiedPropertyName);
    }

    if (storedData.checkin) {
      checkinDate.value = storedData.checkin;
      searchStore.setCheckin(storedData.checkin);
    }

    if (storedData.checkout) {
      checkoutDate.value = storedData.checkout;
      searchStore.setCheckout(storedData.checkout);
    }
    searchStore.setRooms(storedData.rooms)
    rooms.value = storedData.rooms;

  }
}

function getResetData() {
  // Set check-in date to today
  const today = new Date();
  today.setDate(today.getDate() + 14);
  checkinDate.value = today.toISOString().split("T")[0];

  // Set check-out date to 2 days after check-in
  const checkout = new Date(today);
  checkout.setDate(checkout.getDate() + 2);
  checkoutDate.value = checkout.toISOString().split("T")[0];

  // Reset rooms
  rooms.value = [{ adults: 2, children: 0, ages: [] }];
  getPropertyData();
}

function searchByHotelName() {
  if (!searchHotelNameDetail.value) {
    console.warn("Missing hotel name for search.");
    return;
  }

  // Store only the string value
  searchStore.setsearchedHotelName(searchHotelNameDetail.value);
  let hotelName = { searchHotelName: searchHotelNameDetail.value }
  localStorage.setItem("searchedData", JSON.stringify(hotelName));
  localStorage.setItem("componentLoad", "mainView");

  // Change component
  componentChangeStore.changeTheComponent("mainView");
  localStorage.removeItem("propertyDetailsPayload")
}


function getPropertyData() {
  hotels.value = [];
  if (!propertyId.value) {
    console.warn("Missing required data for API request.");
    return;
  }

  const todayDateString = new Date().toISOString().split('T')[0];
  if (!checkinDate.value || !checkoutDate.value || checkinDate.value < todayDateString) {
    // Set default dates if missing or in the past
    const today = new Date();
    today.setDate(today.getDate() + 14);
    checkinDate.value = today.toISOString().split('T')[0];

    const checkout = new Date(today);
    checkout.setDate(checkout.getDate() + 2);
    checkoutDate.value = checkout.toISOString().split('T')[0];
  }
  searchStore.setCheckin(checkinDate.value);
  searchStore.setCheckout(checkoutDate.value);
  searchStore.setRooms(rooms.value);
  const propertyDetailsPayload = {
    propertyId: propertyId.value,
    slugifiedPropertyName: slugifiedPropertyName.value,
    checkin: checkinDate.value,
    checkout: checkoutDate.value,
    rooms: rooms.value
  };
  localStorage.setItem(
    "propertyDetailsPayload",
    JSON.stringify(propertyDetailsPayload)
  );
  searchStore.setRooms(rooms.value)
  api
    .get(
      `/property/details/${propertyDetailsPayload.propertyId}/${propertyDetailsPayload.slugifiedPropertyName}`, {
      params: {
        checkin: propertyDetailsPayload.checkin,
        checkout: propertyDetailsPayload.checkout,
        rooms: propertyDetailsPayload.rooms,
      }
    }
    )
    .then((res) => {
      hotels.value = res.data.data;
      if (res.data.data?.listing?.third_party_type) {
        localStorage.setItem(`third_party_type_${propertyId.value}`, res.data.data.listing.third_party_type);
      }
    })
    .catch((err) => {
      console.log("error", err)
      if (toastRef.value) {
        toastRef.value.addToast(`${err.response?.data?.message} || There is some issue while fetching the hotel details`, "error");
      }
    });
}

function backToMainView() {
  componentChangeStore.changeTheComponent("mainView");
  localStorage.removeItem("propertyDetailsPayload")
  localStorage.removeItem("selectedCheckin")
  localStorage.removeItem("selectedCheckout")
}

async function bookRoom(room) {
  selectedRoomForImages.value = null;
  selectedRoomForPrice.value = null;
  showDialog.value = false;
  await nextTick();
  // Get raw rooms data from searchStore
  const roomsData = searchStore.getRooms;

  // Format occupancy data
  let formattedOccupancy = [];

  if (Array.isArray(roomsData)) {
    formattedOccupancy = roomsData.map((roomItem) => {
      const adultsCount = roomItem.adults;
      const childrenAges = roomItem.ages.map((age) => age + 1).join(","); // Increment child ages by 1
      return childrenAges ? `${adultsCount}-${childrenAges}` : `${adultsCount}`;
    });
  }

  const bookingData = {
    rate_id: room.rates,
    room_id: room.name || room.room_id,
    book_hash: room.book_hash || "",
    meal: room.meal || "",
    listing_id: hotels.value?.listing?.id || "",
    property_id: hotels.value?.propertyId || "",
    checkin: checkinDate.value,
    checkout: checkoutDate.value,
    third_party_type: hotels.value?.listing?.third_party_type || "Ratehawk",
    occupancy: formattedOccupancy,
  };
  bookingStore.addValueToBookingRoom(bookingData);
  localStorage.setItem("bookingData", JSON.stringify(bookingData));

  // Get the current tab ID from URL or localStorage
  const urlParams = new URLSearchParams(window.location.search);
  const tabId = urlParams.get("tabId");
  const currentTabId = tabId || localStorage.getItem("currentTabId") || "main_tab";

  // Store the component state for this specific tab
  localStorage.setItem(`componentLoad_${currentTabId}`, "bookingView");

  // Also update the generic localStorage key (for backward compatibility)
  localStorage.setItem("componentLoad", "bookingView");

  // Always update URL parameters to include the booking view, not just when there's a tabId
  // This ensures the booking view persists on refresh regardless of how the page was opened
  const currentUrl = new URL(window.location.href);

  // Preserve existing parameters like propertyId, propertyName, tabId, etc.
  if (!currentUrl.searchParams.has('propertyId') && propertyId.value) {
    currentUrl.searchParams.set('propertyId', propertyId.value);
  }

  if (!currentUrl.searchParams.has('propertyName') && slugifiedPropertyName.value) {
    currentUrl.searchParams.set('propertyName', slugifiedPropertyName.value);
  }

  if (!currentUrl.searchParams.has('tabId') && currentTabId) {
    currentUrl.searchParams.set('tabId', currentTabId);
  }

  // Set the view to bookingView
  currentUrl.searchParams.set('view', 'bookingView');

  // Replace the current URL with the new one
  window.history.replaceState({}, '', currentUrl.toString());

  document.body.style.overflow = "auto";
  componentChangeStore.changeTheComponent("bookingView");
}
onUnmounted(() => {
  document.body.style.overflow = "auto";
});

</script>
